import { useState } from "react";

import { WarningOutlined } from "@ant-design/icons";
import { Popup } from "devextreme-react/popup";

import { LicenseState } from "../../services/licenseService";

export const LicenseExpiringAlert = ({ licenseState }: { licenseState: LicenseState }) => {
  const [visible, setVisible] = useState(true);

  const organizationName = licenseState.organizationName ?? "your organization";
  const expiresOn = licenseState.expirationDate
    ? licenseState.expirationDate.toLocaleDateString()
    : undefined;
  const daysRemaining = licenseState.daysRemaining ?? 0;
  const dayLabel = daysRemaining === 1 ? "day" : "days";

  return (
    <Popup
      visible={visible}
      onHiding={() => setVisible(false)}
      title="License Expiring Soon"
      showTitle={true}
      showCloseButton={true}
      dragEnabled={false}
      width={440}
      height="auto"
    >
      <div style={{ textAlign: "center", padding: "8px 12px" }}>
        <WarningOutlined style={{ fontSize: 48, color: "#faad14" }} />
        <p style={{ marginTop: 20, marginBottom: 0, fontSize: 15, color: "#595959", lineHeight: 1.6 }}>
          The license for <strong>{organizationName}</strong> will expire in{" "}
          <strong>
            {daysRemaining} {dayLabel}
          </strong>
          {expiresOn ? <> (on <strong>{expiresOn}</strong>)</> : null}. Please contact your
          administrator to renew it and avoid any interruption.
        </p>
      </div>
    </Popup>
  );
};

export default LicenseExpiringAlert;
